// FAQ страницы /support. Вынесен из Support.tsx, чтобы те же вопросы уходили
// в schema.org FAQPage (src/seo/jsonld.ts), расширенный сниппет в выдаче.

export interface SupportFaqItem {
  q: string;
  a: string;
}

export const SUPPORT_FAQ: SupportFaqItem[] = [
  {
    q: 'Сколько времени занимает настройка?',
    a: 'Аккаунт и первое заведение создаются за 5 минут. Полноценный запуск занимает в среднем 1–2 дня: импорт меню, настройка принтеров и обучение команды. Мы помогаем на каждом этапе.',
  },
  {
    q: 'Что делать, если касса не подключается к интернету?',
    a: 'Касса продолжает принимать заказы в офлайн-режиме. Все операции сохраняются локально и синхронизируются с сервером, как только сеть появится. Данные не теряются.',
  },
  {
    q: 'Можно ли отозвать доступ у утерянного iPad?',
    a: 'Да. Зайдите в админ-панель → «Устройства» → нужный iPad → «Отозвать». Устройство мгновенно потеряет доступ к заведению, даже если оно сейчас офлайн: при следующем выходе в сеть сессия закроется.',
  },
  {
    q: 'Какие принтеры поддерживаются?',
    a: 'Любые ESC/POS-принтеры с Bluetooth или по сети: Xprinter, Epson TM, Star, Bixolon. Фискальные кассы интегрируем под запрос (АТОЛ, Эвотор). Напишите в WhatsApp, подскажем совместимые модели.',
  },
  {
    q: 'Мы работаем 24/7, а ваша поддержка?',
    a: 'Поддержка в WhatsApp отвечает ежедневно с 09:00 до 22:00 МСК. Для тарифа Business и выше доступна круглосуточная дежурная линия с ответом в течение 15 минут на критичные инциденты.',
  },
];
